import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Logo } from '@/components/Logo';
import { corporateWebDestination, isCorporateWebRole } from '@/lib/corporate-web-policy.mjs';

export default function CorporateWebOnly() {
  const { user, logout } = useAuth();
  const url = corporateWebDestination({ backendOrigin: process.env.REACT_APP_BACKEND_URL, role: user?.role });
  return <main className="min-h-[100dvh] bg-[#0A0A0A] px-6 py-10 text-white" data-testid="corporate-web-only">
    <div className="mx-auto max-w-md space-y-6">
      <Logo size="sm" />
      <h1 className="text-2xl font-bold">Portal disponible en la web</h1>
      <p className="text-neutral-300">Las aseguradoras y empresas gestionan sus solicitudes, servicios y documentos desde la página web de C&A.</p>
      <a href={url} target="_blank" rel="noopener noreferrer" className="block rounded-xl bg-[#E63946] px-4 py-3 text-center font-semibold">Abrir portal web</a>
      {isCorporateWebRole(user?.role)
        ? <button type="button" onClick={logout} className="min-h-12 w-full rounded-xl border border-white/25 px-4 py-3">Cerrar sesión</button>
        : <Link to="/app" className="block py-3 text-center underline">Volver a la aplicación</Link>}
    </div>
  </main>;
}
